import { render, staticRenderFns } from "./AllAssistants.vue?vue&type=template&id=72b9928c&"
import script from "./AllAssistants.vue?vue&type=script&lang=ts&"
export * from "./AllAssistants.vue?vue&type=script&lang=ts&"
import style0 from "./AllAssistants.vue?vue&type=style&index=0&id=72b9928c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports